import React from "react";
import Question from "./question";
import Answers from "./answers";
import { useNavigate } from "react-router-dom";
import { QuesLoader } from "../../util/common";

const TestTakerQuestions28 = (props) => {
    const { dataQuestion, label_text, isWarmUp, moveNextQuest, addKeyPressed, phrases, phase } = props;
    const navigate = useNavigate();

    if (isWarmUp && !dataQuestion) {
        return navigate("/" + sessionStorage.getItem("urlParams"));
    }

    let multiArray = [];
    const inputSize = dataQuestion.length;
    const rowsCount = (inputSize / 5).toFixed();
    let index = 0, columnsCount = 5;

    for (var i = 0; i < rowsCount; i++) {
        var temp = [];
        if (i === rowsCount - 1) {
            if (Math.floor(inputSize / 5) * 5 !== inputSize) {
                columnsCount = inputSize - (Math.floor(inputSize / 5)) * 5;
            }
        }

        for (var j = 0; j < columnsCount; j++) {
            temp.push({ 'text': dataQuestion[index], 'number': index + 1 });
            index++;
        }
        multiArray[i] = temp;

    }

    return (
        <form id='inputForm' className="g-item_12  g5 flex align-self-stretch align-items_start position_relative">
            <QuesLoader show={phase === "showing-loader"} />
            <div className={`g-item_6 flex_col g2 align-items_start align-self-stretch shown ${phase}`}>
                <p className="small-title m0"> {phrases?.["13106"]} </p>
                <div className="full-width flex_col p4 align-items_start g2 align-self-stretch roundness_1 question-brdr">
                    {multiArray.map((items, index) => {
                        return (
                            <div key={index} className="flex g2 align-self-stretch align-items_start">
                                {items.map((subItems, sIndex) => {
                                    return (
                                        <div id={subItems.number}>
                                            <label className="caption">
                                                {label_text} {subItems.number}
                                            </label>
                                            <input className="num-txt-val pr0" value={subItems.text} placeholder="Placeholder text" type="text" disabled />
                                        </div>
                                    )
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={`g-item_6 flex_col g2 align-items_start align-items_start shown ${phase}`}>
                <p className="small-title m0">{phrases?.["15267"]}</p>
                <div className="full-width flex_col p4 align-items_start g2 align-self-stretch roundness_1 question-brdr">
                    {multiArray.map((items, index) => {
                        return (
                            <div key={index} className="flex g2 align-self-stretch align-items_start">
                                {items.map((subItems, sIndex) => {
                                    return <Answers label_text={label_text} label_no={subItems.number} key={sIndex}
                                        eventListenTab={(e) => {
                                            if (subItems.number === inputSize) {
                                                e.preventDefault();
                                                moveNextQuest();
                                            }
                                        }} keyCount={() => addKeyPressed()} />;
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        </form>
    );
};

export default TestTakerQuestions28;
